var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * SoundUp component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconSoundUp extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.5542 9.65771C20.5542 9.2435 20.2184 8.90771 19.8042 8.90771C19.39 8.90771 19.0542 9.2435 19.0542 9.65771V11.2495H17.4629C17.0487 11.2495 16.7129 11.5853 16.7129 11.9995C16.7129 12.4137 17.0487 12.7495 17.4629 12.7495H19.0542V14.34C19.0542 14.7542 19.39 15.09 19.8042 15.09C20.2184 15.09 20.5542 14.7542 20.5542 14.34V12.7495H22.1452C22.5594 12.7495 22.8952 12.4137 22.8952 11.9995C22.8952 11.5853 22.5594 11.2495 22.1452 11.2495H20.5542V9.65771Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.8845 3.69099C13.5172 3.51554 13.11 3.44023 12.7043 3.47269C12.2985 3.50515 11.9085 3.64422 11.5737 3.87583L5.52021 8.12842H3.41624C2.80337 8.12842 2.21563 8.37188 1.78229 8.80521L1.78227 8.80523C1.34893 9.23858 1.10547 9.82632 1.10547 10.4392V13.5607C1.10547 14.1736 1.34893 14.7613 1.78227 15.1947L1.78229 15.1947C2.21563 15.628 2.80337 15.8715 3.41624 15.8715H5.51589L11.4222 20.1163L11.4333 20.124C11.768 20.3556 12.158 20.4947 12.5638 20.5271C12.9666 20.5594 13.3709 20.4854 13.7361 20.3126C14.131 20.1334 14.4676 19.8467 14.7072 19.4851C14.9485 19.1211 15.0817 18.6962 15.0914 18.2596L15.0916 18.243V5.76489C15.0997 5.35327 14.9976 4.9469 14.7959 4.58786C14.5926 4.22598 14.2956 3.92553 13.936 3.71811C13.9192 3.7084 13.902 3.69936 13.8845 3.69099ZM6.50739 14.7369L12.2914 18.8936C12.4078 18.973 12.5429 19.0207 12.6834 19.0319C12.8258 19.0433 12.9686 19.0169 13.0975 18.9553L13.1134 18.9479C13.2532 18.8851 13.3723 18.784 13.457 18.6563C13.5404 18.5306 13.587 18.3841 13.5916 18.2333V5.75683L13.5918 5.73897C13.5953 5.59338 13.5595 5.44953 13.4881 5.32256C13.4216 5.20407 13.3264 5.10435 13.2114 5.03241C13.0896 4.97952 12.9565 4.9573 12.8239 4.96791C12.6822 4.97925 12.5461 5.02759 12.429 5.1081L6.50739 9.26806V14.7369ZM2.84294 9.86588L2.84293 9.86589V14.134L2.84294 14.134C2.995 14.2861 3.20121 14.3715 3.41624 14.3715H5.00739V9.62842H3.41624C3.20122 9.62842 2.995 9.71383 2.84294 9.86588Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconSoundUp.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconSoundUp.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconSoundUp.prototype, "size", void 0);
if (customElements.get('cat-icon-sound-up') === undefined) {
    customElements.define('cat-icon-sound-up', BlocksIconSoundUp);
}
